import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    render() {

        const LoanIssuedDetailsInput = this.props.LoanIssuedDetailsInput;
        const LoanReportTotal = this.props.LoanReportTotal;
        const LoanReportData = this.props.LoanReportData;
        const LoanIssuedSearchData = this.props.LoanIssuedSearchData;

        return (
            <div>

                <h2><center><u>Loan Issued Details Report</u></center></h2>
                <div>&nbsp;</div>
                <h4><center>Group :{LoanIssuedSearchData.groupName}</center></h4>
                <h4><center>Factory :{LoanIssuedSearchData.factoryName}</center></h4>
                <h4><center>Route :{LoanIssuedSearchData.routeName===undefined?"All Routes":LoanIssuedSearchData.routeName} </center></h4>
                <h4><center>From :{LoanIssuedDetailsInput.startyear === "" ? moment(new Date()).format('YYYY') : LoanIssuedDetailsInput.startyear} / {LoanIssuedDetailsInput.startmonth === "" ? moment(new Date()).format('MMMM') : LoanIssuedSearchData.startmonth} -To :{LoanIssuedDetailsInput.endyear === "" ? moment(new Date()).format('YYYY') : LoanIssuedDetailsInput.endyear} / {LoanIssuedDetailsInput.endmonth === "" ? moment(new Date()).format('MMMM') : LoanIssuedSearchData.endmonth}
                 </center></h4>
                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050}>

                        <TableContainer >
                            <Table aria-label="caption table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Route Name</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Month</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Registration Number</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Customer Name</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Loan Issued Date</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Principal Amount (Rs.)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {LoanReportData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.routeName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {moment(new Date(data.loanIssuedDate)).format('MMMM')}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.registrationNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.name}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.loanIssuedDate.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                            {data.principalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}                                             
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableRow>
                                    <TableCell align={'center'} style={{ border: "1px #ccc solid" }}><b>Total</b></TableCell>
                                    <TableCell align={'center'} component="th" scope="row"></TableCell>
                                    <TableCell align={'center'} component="th" scope="row" ></TableCell>
                                    <TableCell align={'center'} component="th" scope="row" ></TableCell>
                                    <TableCell align={'center'} component="th" scope="row" ></TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                        <b> {LoanReportTotal.principalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </b>
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}